import { render } from "./ScreenNav.vue?vue&type=template&id=b99ad878&scoped=true&ts=true"
import script from "./ScreenNav.vue?vue&type=script&lang=ts"
export * from "./ScreenNav.vue?vue&type=script&lang=ts"

import "./ScreenNav.vue?vue&type=style&index=0&id=b99ad878&lang=scss&scoped=true"

import exportComponent from "/Users/n0x/w4_proj/zigmodu_ws/heysen_saas/site/datax/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99ad878"]])

export default __exports__